<div
  class="flex flex-col overflow-hidden flex-1 min-h-0"
  [style.zoom]="zoom()"
>
  @if (!alwaysShowTable() && isLoading() && rows().length === 0) {
    <app-skeleton-table />
  } @else if (!alwaysShowTable() && rows().length === 0) {
    <avs-no-data-placeholder
      [hasBigPadding]="noDataBigPadding()"
      [noDataText]="noDataText()"
      [resultContent]="noDataResultContent()"
    />
  } @else {
    <cdk-virtual-scroll-viewport
      class="flex-1 min-h-0 overflow-auto"
      (loadMore)="onLoadMore()"
      [avsLoadMore]="loadMoreThreshold()"
      [itemSize]="rowHeight()"
    >
      <cdk-virtual-scroll-viewport-wrapper>
        <table
          class="avs-datagrid-table main-table"
          (matSortChange)="sortChange.emit($event)"
          [dataSource]="rows()"
          [matSortActive]="sort()?.active ?? ''"
          [matSortDirection]="sort()?.direction ?? ''"
          [trackBy]="effectiveTrackBy()"
          mat-table
          matSort
        >
          @if (selectable()) {
            <ng-container
              [sticky]="stickyColumns() && firstVisibleColumn()?.sticky === 'start'"
              matColumnDef="select"
            >
              <th
                *matHeaderCellDef
                mat-header-cell
              >
                @if (selectAll()) {
                  <mat-checkbox
                    (change)="$event && toggleAllRows()"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                  />
                }
              </th>

              <td
                *matCellDef="let row"
                mat-cell
              >
                <mat-checkbox
                  (change)="$event && selection.toggle(row.id)"
                  (click)="$event.stopPropagation()"
                  [checked]="selection.isSelected(row.id)"
                />
              </td>
            </ng-container>
          }

          @for (column of columns(); track column.id) {
            <ng-container
              [matColumnDef]="column.id"
              [sticky]="stickyColumns() && column.sticky === 'start'"
              [stickyEnd]="stickyColumns() && column.sticky === 'end'"
            >
              @let resizeEnabled = resizableColumns() && (column.resizable ?? column.sticky !== 'end');

              @if (column.sortable) {
                <th
                  [avsColumnResize]="resizeEnabled"
                  [avsColumnResizeColumn]="column.id"
                  [avsColumnResizeTable]="tableId()"
                  [class]="column.headerClass"
                  *matHeaderCellDef
                  mat-header-cell
                  mat-sort-header
                >
                  {{ column.title }}
                </th>
              } @else {
                <th
                  [avsColumnResize]="resizeEnabled"
                  [avsColumnResizeColumn]="column.id"
                  [avsColumnResizeTable]="tableId()"
                  [class]="column.headerClass"
                  *matHeaderCellDef
                  mat-header-cell
                >
                  {{ column.title }}
                </th>
              }

              <td
                [class]="column.cellClass"
                *matCellDef="let row; let i = index"
                mat-cell
              >
                @if (cellTemplateFor(column.id); as template) {
                  <ng-container
                    [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{ $implicit: row, index: i }"
                  />
                } @else if (column.type === 'metric' && column.metric; as metric) {
                  <avs-metric-cell
                    [estimated]="metric.estimated ? metric.estimated(row) : null"
                    [formatter]="metric.formatter"
                    [nullTooltip]="metric.nullTooltip"
                    [value]="metric.value(row)"
                    [zeroTooltip]="metric.zeroTooltip"
                  />
                }
              </td>
            </ng-container>
          }

          <tr
            *matHeaderRowDef="displayedColumnIds(); sticky: true"
            mat-header-row
          ></tr>
          <tr
            [class]="rowClass()?.(row)"
            *matRowDef="let row; columns: displayedColumnIds()"
            mat-row
          ></tr>
        </table>
      </cdk-virtual-scroll-viewport-wrapper>
    </cdk-virtual-scroll-viewport>

    @if (showLoadMoreSpinner() && isLoading() && rows().length > 0) {
      <div class="flex justify-center py-2">
        <mat-progress-spinner
          diameter="24"
          mode="indeterminate"
        />
      </div>
    }
  }
</div>

@if (zoomControls()) {
  <app-table-zoom
    (zoomChanged)="zoom.set($event)"
    [tableId]="tableId()"
  />
}
